import { ChangeDetectionStrategy, Component } from '@angular/core';

import { MenuItemWrapper } from '../menu-utils/menu-utils';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ds-menu-interactive-item',
  template: `<li
    class="ds-menu-item"
    [class.ds-disabled]="$isDisabled()"
    [attr.aria-current]="$_isSelected() ? 'true' : null"
  >
    <button class="ds-menu-item">
      <ng-content></ng-content>
    </button>
  </li>`,
})
export class MenuInteractiveItemComponent extends MenuItemWrapper { }
